import { client } from '../apiClient';
import { SuggestedPromptsResponse } from '../../models/suggested-prompts/SuggestedQuestions';

const PROJECTS_ENDPOINT = '/suggested-questions';

export const getSuggestedQuestions = async (projectId: number): Promise<SuggestedPromptsResponse> => {
  return client(true, true)
    .get<SuggestedPromptsResponse>(`${PROJECTS_ENDPOINT}/${projectId}`)
    .then((response) => response.data);
};
